export const COMMUNITY_REVIEWS_QUERY_KEY = "communityReviews";
export const VENDOR_REVENDORIZATIONS_QUERY_KEY = "vendorRevendorizations";
export const BULLMQ_QUEUES_QUERY_KEY = "bullmqQueues";
export const BULLMQ_JOBS_QUERY_KEY = "bullmqJobs";
export const BULLMQ_JOB_QUERY_KEY = "bullmqJob";
export const SUPPORT_USER_PLAID_STATUS_QUERY_KEY = "supportUserPlaidStatus";
export const SUPPORT_PLAID_TRANSACTIONS_QUERY_KEY = "supportPlaidTransactions";
export const SUPPORT_GDPR_EXPORT_STATUS_QUERY_KEY = "supportGdprExportStatus";
export const CARBON_OFFSET_CONTRACTS_QUERY_KEY = "carbonOffsetContracts";
export const CARBON_OFFSET_SUPPLIERS_QUERY_KEY = "carbonOffsetSuppliers";
export const CARBON_OFFSET_PROJECTS_QUERY_KEY = "carbonOffsetProjects";
export const CARBON_OFFSET_INVENTORY_POOLS_QUERY_KEY = "carbonOffsetInventoryPools";
export const CARBON_OFFSET_PORTFOLIOS_QUERY_KEY = "carbonOffsetPortfolios";
export const CARBON_OFFSET_CLIENTS_QUERY_KEY = "carbonOffsetClients";
export const SPENDING_AGGREGATIONS_QUERY_KEY = "spendingAggregations";
export const SUPPORT_CATEGORIZED_TRANSACTIONS_QUERY_KEY =
  "supportCategorizedTransactions";
export const SUPPORT_USER_CATEGORIES_QUERY_KEY = "supportUserCategories";
export const SUPPORT_USER_BUDGET_STATUS_QUERY_KEY =
  "supportUserBudgetStatus";
